<template>
    <div>
        <DataTable
            :value="users"
            :lazy="true"
            paginator
            :rows="10"
            @page="onPage"
            @sort="onSort"
            sortMode="multiple"
            selectionMode="single"
            :loading="loading"
            dataKey="id"
            :totalRecords="totalUserRecords"
            responsiveLayout="scroll"
            :globalFilterFields="['name', 'surname', 'email']"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            paginatorTemplate="CurrentPageReport JumpToPageInput FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries :: Page No:"
        >
            <template #empty> No Unassessed Users available. </template>
            <Column field="id" header="USER ID"></Column>
            <Column field="name" header="NAME">
                <template #body="slotProps">
                    <div class="capitalize" @click="selectUser(slotProps.data.id)">
                        {{ slotProps.data.name }}
                    </div>
                </template>
            </Column>
            <Column field="surname" header="SURNAME">
                <template #body="slotProps">
                    <div class="capitalize" @click="selectUser(slotProps.data.id)">
                        {{ slotProps.data.surname }}
                    </div>
                </template>
            </Column>
            <Column field="email" header="EMAIL">
                <template #body="slotProps">
                    <div @click="selectUser(slotProps.data.id)">
                        {{ slotProps.data.email }}
                    </div>
                </template>
            </Column>
            <Column header="ACTIONS" style="width: 200px">
                <template #body="slotProps">
                    <Button
                        icon="pi pi-bolt"
                        class="p-button-rounded p-button-help"
                        @click="selectUser(slotProps.data.id)"
                        label="Start Assessment"
                        v-tooltip="'Start an assessment for this user'"
                    />
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useAnswerStore } from '../store';

const router = useRouter();
const answerStore = useAnswerStore();

const { loading, criteria } = storeToRefs(answerStore);

// Local state for unassessed users
const users = ref([]);
const totalUserRecords = ref(0);
const lazyParams = ref({});

onMounted(async () => {
    lazyParams.value = {
        first: 0,
        rows: 10,
        page: null,
        sort: null,
    };
    await loadLazyData();
});

watch(
    () => criteria.value,
    async () => {
        // Reset to first page when criteria changes
        lazyParams.value.first = 0;
        lazyParams.value.page = 1;
        await loadLazyData();
    },
    { deep: true }
);

const loadLazyData = async () => {
    const response = await answerStore.getUnassessedUsers(lazyParams.value);
    if (response) {
        users.value = response.data || [];
        totalUserRecords.value = response.total || 0;
    }
};

const onPage = async (event) => {
    lazyParams.value = event;
    await loadLazyData();
};

const onSort = (event) => {
    const sortings = event.multiSortMeta;
    lazyParams.value.sort = sortings
        .map((item) => {
            return item.field + ' ' + (item.order === 1 ? 'asc' : 'desc');
        })
        .join(',');
    loadLazyData();
};

function selectUser(id) {
    router.push({ name: 'UserSpecificAnswersTable', params: { userId: id } });
}
</script>